import React, {ReactElement} from 'react';
import './distributionPanel.scss';
import colors from '../../../../style/_chartColors.module.scss';
import {ColoredBar, Segment} from "../../../../component/progressBar/ColoredBar";
import _ from "lodash";
import {TrendIcon} from "../trend/TrendIcon";
import classNames from 'classnames';
import classnames from 'classnames';
import {TableItem, TableItemUI, TableUIData} from "../../visualizations/table/AbstractTableViz";
import {services} from "../../../../application/service/services";
import {withTranslation, WithTranslation} from "react-i18next";
import {DataRenderer} from "../../../../component/table/DataRenderer";

interface DistributionPanelProps extends WithTranslation {
    data: TableUIData,
    mode?: 'percent' | 'volume',
    detailedMode: boolean,
    isTwoLevels: boolean,
    showNetSentiment: boolean,
    showPercent: boolean,
    showVolume: boolean,
    showTrend: boolean,
    className?: string,
    color?: string;
    onClick?: (item: TableItemUI, event: MouseEvent) => any;
}


class DistributionPanelComp extends React.PureComponent<DistributionPanelProps> {

    protected getVolume(item: TableItem): { count: number, percent: number } {
        return item.data.find(
            x => x.name === "volume"
        )?.value;
    }

    render() {
        const {
            className,
            data,
            showPercent,
            showVolume,
            showTrend,
            color,
            t,
            showNetSentiment,
            detailedMode,
            isTwoLevels
        } = this.props;

        const parent = data;

        let gridTemplateColumns = '[label] max-content [bar] auto';
        if (showPercent) gridTemplateColumns += ' [percent] max-content';
        if (showVolume) gridTemplateColumns += ' [volume] max-content';
        if (showTrend) gridTemplateColumns += ' [trend] max-content';
        if (showNetSentiment) gridTemplateColumns += ' [netSentiment] max-content';

        const labelHeader = 'Topics'//services.getFieldsService().getField(item.field);
        const legendItems = {};
        let useRatioFn = false;

        const maxFirstLevelValue = data.items.map(value => this.getVolume(value).count || 0)
            .reduce((maxValue, currentValue) => {
                const currentItemVolume = currentValue || 0;
                const maxItemVolume = maxValue || 0;
                return currentItemVolume > maxItemVolume ? currentItemVolume : maxValue
            });

        const bars = data.items
            .filter(item => !isTwoLevels || item.children && item.children.length > 0)
            .map(item => {
                const field = services.getFieldsService().getField(item.field);
                const fieldValue = services.getFieldsService().getFieldValues(field.name);
                const label = fieldValue && fieldValue.find(item.fieldValue) ? fieldValue.find(item.fieldValue).getLabel(t) : item.fieldValue;
                const volume = item.data?.find(d => d.name === 'volume')?.value.count || 0;
                const percent = item.data?.find(d => d.name === 'volume')?.value.percent || 0;

                const tonalities = item.data.filter(columnValue => columnValue.name === 'tonalities').find(() => true)?.value;
                const net_sentiment = tonalities ? DataRenderer.getPropertyIgnoreCase(tonalities, 'POSITIVE') - DataRenderer.getPropertyIgnoreCase(tonalities, 'NEGATIVE') : null;
                const colorToUse = color ? color : services.getColorService().getColorForFieldValue(item.field, item.fieldValue)
                const trend = item.data?.find(d => d.name === 'volume_trend')?.value || 0;
                const segments = [];
                let showTooltip = true;
                if (isTwoLevels) {
                    if (!detailedMode) {
                        showTooltip = false;
                        let childrenWithMaxCount = item.children.reduce((maxItem, currentItem) => {
                            const currentItemVolume = this.getVolume(currentItem).count || 0;
                            const maxItemVolume = this.getVolume(maxItem).count || 0;
                            return currentItemVolume > maxItemVolume ? currentItem : maxItem
                        });
                        const childrenWithMaxCountLbl = services.getFieldsService().findFieldValue(childrenWithMaxCount.field, childrenWithMaxCount.fieldValue)?.getLabel(t) || childrenWithMaxCount.fieldValue;
                        const childrenWithMaxCountPercent = this.getVolume(childrenWithMaxCount).count * 100 / item.childrenCount;
                        const childrenWithMaxCountColors = this.getColorsFromPercentage(childrenWithMaxCountPercent)
                        segments.push({
                            item: childrenWithMaxCount,
                            value: 100,
                            percent: 100,
                            text: childrenWithMaxCountLbl + ' . ' + _.round(childrenWithMaxCountPercent, 0) + '%',
                            textStyle: {
                                color: childrenWithMaxCountColors.color,
                                fontWeight: 'bold',
                                paddingLeft: "10px",
                                display: 'flex',
                                alignItems: 'center',
                                height: '100%'
                            },
                            color: childrenWithMaxCountColors.background
                        });
                    } else {
                        let computedChildrenCount = 0;
                        item.children?.forEach(d => {
                            const childVolume = d.data?.find(d => d.name === 'volume');
                            computedChildrenCount += childVolume?.value.count || 0;
                            const percent = item.childrenCount > 0 ? (childVolume?.value.count * 100) / item.childrenCount : 0
                            const segment = {
                                item: d,
                                label: services.getFieldsService().findFieldValue(d.field, d.fieldValue)?.getLabel(t) || d.fieldValue,
                                textStyle: {
                                    color: 'white',
                                    fontWeight: 'bold',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%'
                                },
                                text: percent > 5 ? _.round(percent, 0) + '%' : undefined,
                                value: childVolume?.value.count || 0,
                                percent: percent,
                                color: color ? color : services.getColorService().getColorForFieldValue(d.field, d.fieldValue)
                            }
                            segments.push(segment);

                            legendItems[segment.label] = segment.color;
                        });
                        if (item.childrenCount > computedChildrenCount) {
                            const otherVolume = item.childrenCount - computedChildrenCount;
                            const percent = item.childrenCount > 0 ? (otherVolume * 100) / item.childrenCount : 0;
                            segments.push({
                                label: t('dashboard.viz.distributionChart.group.other'),
                                text: percent > 5 ? _.round(percent, 0) + '%' : undefined,
                                textStyle: {
                                    color: 'white',
                                    fontWeight: 'bold',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%'
                                },
                                value: otherVolume,
                                percent: percent,
                                color: color ? color : services.getColorService().getOtherColor()
                            });
                        }
                    }
                } else {
                    useRatioFn = true;
                    segments.push({
                        item: item,
                        value: volume || 0,
                        percent: percent,
                        color: showNetSentiment && !_.isNil(net_sentiment) ? colors[this.getNetSentimentColorClass(net_sentiment)] : colorToUse
                    });
                }


                return (<React.Fragment key={item.field}>
                    <div className="distributionPanelLabel" onClick={this.getOnClickHandler(item)}>{label}</div>
                    <div className="distributionPanelBar">
                        <ColoredBar segments={segments} style={{height: '30px'}} minWidth={16} minWidthUnit={'px'}
                                    computeRatioFn={useRatioFn ? this.getRatioFn(maxFirstLevelValue) : undefined}
                                    onClickSegment={(event, segment) => {
                                        this.getOnClickHandler(segment.item)(event)
                                    }}
                                    tooltipContent={showTooltip ? this.getTooltipContent : undefined}/></div>
                    {showPercent ?
                        <div
                            className="distributionPanelPercent">{_.round(percent, 2)}%</div> : null}
                    {showVolume ? <div
                        className="distributionPanelVolume">{showPercent ? "  " : ""}({volume})</div> : null}
                    {showNetSentiment ?
                        <div className="distributionPanelNetSentiment" onClick={this.getOnClickHandler(item)}>
                            {!_.isNil(net_sentiment) && (<div
                                className={classnames('net_sentiment', this.getNetSentimentColorClass(net_sentiment))}>{net_sentiment}</div>)}
                        </div> : null}
                    {showTrend ?
                        <div className="distributionPanelTrend" onClick={this.getOnClickHandler(item)}>
                            {!_.isNil(trend) && (<TrendIcon value={trend} size={18}/>)}
                        </div> : null}
                </React.Fragment>)
            })

        return <>
            {
                legendItems && Object.keys(legendItems).length > 0 ? <div className="distributionPanelLegend">
                    {Object.entries(legendItems).map(([label, color], index) => (
                        <div key={index} className="legend-item">
                            <div className="legend-color" style={{backgroundColor: color as any}}></div>
                            <span className="legend-label">{label}</span>
                        </div>
                    ))}
                </div> : null
            }
            <div className={classNames('distributionPanel', className)}
                 style={{gridTemplateColumns: gridTemplateColumns}}>


                <div className="distributionPanelLabel header">{labelHeader}</div>
                <div className="distributionPanelBar header"></div>

                {showPercent ? <div className="distributionPanelPercent header"></div> : null}
                {showVolume ?
                    <div className="distributionPanelVolume header">{t('dashboard.viz.table.volume')}</div> : null}
                {showNetSentiment ? <div
                    className="distributionPanelNetSentiment header">{t('dashboard.viz.table.netSentiment')}</div> : null}
                {showTrend ?
                    <div className="distributionPanelTrend header">{t('dashboard.viz.table.trend')}</div> : null}
                {bars}
            </div>
        </>;
    }

    private getTooltipContent = (segment: Partial<Segment>): ReactElement => {
        return <div className="tooltip">
            <div className="tooltip-label">
                <span>{(segment as any).label}</span>
            </div>
            <span className="tooltip-value">{segment.value}</span>
            <span className="tooltip-percent">{_.round(segment.percent, 2)}%</span>
        </div>
    }

    private getNetSentimentColorClass(net_sentiment: number) {
        return net_sentiment <= -25 ? 'negative' : net_sentiment < 0 ? 'warning' : 'positive';
    }

    private getOnClickHandler(item: TableItemUI) {
        return (event) => {
            if (this.props.onClick) {
                event.stopPropagation();
                this.props.onClick(item, event);
            }
        }
    }

    private getColorsFromPercentage(childrenWithMaxCountPercent: number): {
        background: string, color
            :
            string
    } {
        if (childrenWithMaxCountPercent >= 55) return {background: "#00264D", color: 'white'};
        if (childrenWithMaxCountPercent >= 40) return {background: "#0E5B94", color: 'white'};
        if (childrenWithMaxCountPercent >= 28) return {background: "#3B8AC7", color: 'white'};
        if (childrenWithMaxCountPercent >= 20) return {background: "#89BADE", color: '#00264D'};
        return {background: "#D0E3F2", color: '#0E5B94'};
    }


    private getRatioFn(maxFirstLevelValue: number) {
        return (pct, value, total) => {
            return Math.sqrt(value / maxFirstLevelValue);
        }
    }
}

export const DistributionPanel = withTranslation()(DistributionPanelComp);